// The ES5 build: react-scripts 1 cannot minify the ES module one (xlsx.mjs).
// eslint-disable-next-line import/extensions
import XLSX from 'xlsx/xlsx.js';

// The API does the real validation (C- prefix, case, spaces, 12 hex digits);
// this only finds the column of MAC addresses in a factory spreadsheet.
const looksLikeMac = (value) => /^[0-9A-F]{12}$/.test(
  String(value).trim().replace(/^c\s*-/i, '').replace(/[\s:-]/g, '')
    .toUpperCase(),
);

const HEADER = /serial|mac/i;

const cellText = (value) => (value == null ? '' : String(value).trim());

/**
 * The entries of the MAC column of one sheet: the column titled "Serial #" or
 * "MAC…" (its first such header), else the column holding the most MAC-like
 * values. Every non-empty cell under it is kept, typos included, so the
 * preview can list what needs correcting.
 */
const sheetEntries = (rows) => {
  const width = Math.max(0, ...rows.map((row) => row.length));
  let column = -1;
  let headerRow = -1;
  rows.slice(0, 5).some((row, r) => {
    const c = row.findIndex((cell) => HEADER.test(cellText(cell)));
    if (c !== -1) {
      column = c;
      headerRow = r;
    }
    return c !== -1;
  });
  if (column === -1) {
    let best = 0;
    for (let c = 0; c < width; c += 1) {
      const macs = rows.filter((row) => looksLikeMac(cellText(row[c]))).length;
      if (macs > best) {
        best = macs;
        column = c;
      }
    }
  }
  if (column === -1) return [];
  return rows.slice(headerRow + 1).map((row) => cellText(row[column])).filter(Boolean);
};

/**
 * Reads an xlsx/xls/csv file and returns the MAC entries of its visible sheets.
 */
const readMacSpreadsheet = async (file) => {
  const data = await file.arrayBuffer();
  const workbook = XLSX.read(data, { type: 'array' });
  const sheetInfo = (workbook.Workbook && workbook.Workbook.Sheets) || [];
  const visible = workbook.SheetNames.filter((name, i) => !(sheetInfo[i] && sheetInfo[i].Hidden));
  const sheets = visible.map((name) => ({
    name,
    entries: sheetEntries(XLSX.utils.sheet_to_json(workbook.Sheets[name], {
      header: 1, raw: false, defval: '', blankrows: false,
    })),
  })).filter(({ entries }) => entries.length);
  return {
    sheetNames: sheets.map(({ name }) => name),
    entries: sheets.flatMap(({ entries }) => entries),
  };
};

export default readMacSpreadsheet;



// WEBPACK FOOTER //
// ./src/components/lovebox-info/mac-spreadsheet.js